import React from 'react';
import {Modal, Typography, Button, Radio, Input, Flex, theme} from 'antd';
import {CloseIconDialog} from 'Components';
import {useCSContext} from 'Context/ContentStackContext';
import {REFILL_REASONS} from 'Utils/constants/genericConstants';

const {Title, Text} = Typography;

const RefulfillDialog = (props) => {
  const {visible, onModalClose} = props;
  const {artifacts} = useCSContext();
  const {token}: any = theme.useToken();

  return (
    <Modal destroyOnHidden open={visible} onCancel={onModalClose} footer={null} closable={false}>
      <CloseIconDialog callback={onModalClose} image={artifacts.cross_icon} />
      <Title level={3} style={{paddingTop: 32, marginBottom: 0}}>
        Re-Fulfill Order
      </Title>
      <Text
        strong
        style={{
          display: 'block',
          marginTop: 16,
          marginBottom: 8,
          fontSize: 12,
          color: token.colorTextSecondary,
        }}>
        REASON FOR RE-FULFILL
      </Text>

      {/* checkedState/onModalSelectChange are driven per-index by the caller
          (not a single controlled value), so this stays individual Radios
          rather than a Radio.Group, matching the original's behavior exactly. */}
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: '1fr 1fr',
          gap: 8,
          padding: 12,
          border: `1px solid ${token.colorBorderSecondary}`,
          borderRadius: token.borderRadiusLG,
        }}>
        {REFILL_REASONS.map((key, index) => (
          <Radio
            key={key}
            onChange={() => props.onModalSelectChange(index)}
            checked={props.checkedState[index]}>
            {key}
          </Radio>
        ))}
      </div>

      <Text
        strong
        style={{
          display: 'block',
          marginTop: 16,
          marginBottom: 8,
          fontSize: 12,
          color: token.colorTextSecondary,
        }}>
        COMMENTS
      </Text>
      <Input.TextArea
        placeholder="Add context for this re-fulfillment…"
        rows={3}
        onChange={(e) => props.onModalTextChange(e)}
      />
      <Flex justify="flex-end" gap={10} style={{marginTop: 24}}>
        <Button onClick={onModalClose}>Cancel</Button>
        <Button type="primary" onClick={props.onSubmitModal}>
          Submit Re-fulfillment Order
        </Button>
      </Flex>
    </Modal>
  );
};

export default RefulfillDialog;
